import { render, staticRenderFns } from "./RegionManagement.vue?vue&type=template&id=e6f551a2&scoped=true"
import script from "./RegionManagement.vue?vue&type=script&lang=js"
export * from "./RegionManagement.vue?vue&type=script&lang=js"
import style0 from "./RegionManagement.vue?vue&type=style&index=0&id=e6f551a2&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/.pnpm/vue-loader@15.11.1_j7knk6mol3vthgvrc443rvn57u/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e6f551a2",
  null
  
)

export default component.exports